import { render } from "./performance-training.vue?vue&type=template&id=fcfcb462"
import script from "./performance-training.vue?vue&type=script&lang=js"
export * from "./performance-training.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__